export default __webpack_public_path__ + "static/media/955.4bc34b8d.gif";